interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "menu-dots (1) 4" (4-way move) asset from the PAGES tab Figma component. */
const FigmaMoveIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16.0447 16.0447'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.42614 0.16722L10.7185 2.45958C10.9426 2.68366 10.9426 3.04585 10.7185 3.26993C10.4944 3.49401 10.1322 3.49401 9.90815 3.26993L8.59406 1.95583L8.59406 7.44947H14.0877L12.7736 6.13538C12.5495 5.9113 12.5495 5.54911 12.7736 5.32503C12.9977 5.10095 13.3599 5.10095 13.584 5.32503L15.8763 7.61739C16.0935 7.83402 16.1067 8.19793 15.8763 8.42831L13.584 10.7207C13.3599 10.9448 12.9977 10.9448 12.7736 10.7207C12.5495 10.4966 12.5495 10.1344 12.7736 9.91032L14.0877 8.59565H8.59406L8.59406 14.0893L9.90815 12.7752C10.1322 12.5511 10.4944 12.5511 10.7185 12.7752C10.9426 12.9993 10.9426 13.3615 10.7185 13.5855L8.42614 15.8779C8.20436 16.0997 7.83873 16.1014 7.61522 15.8779L5.32286 13.5855C5.09878 13.3615 5.09878 12.9993 5.32286 12.7752C5.54694 12.5511 5.90913 12.5511 6.13321 12.7752L7.44788 14.0893L7.44788 8.59565H1.95424L3.26833 9.90975C3.49241 10.1338 3.49241 10.496 3.26833 10.7201C3.04425 10.9442 2.68206 10.9442 2.45798 10.7201L0.165624 8.42774C-0.0561617 8.20595 -0.057881 7.84032 0.165624 7.61682L2.45798 5.32446C2.68206 5.10038 3.04425 5.10038 3.26833 5.32446C3.38009 5.43678 3.43625 5.58349 3.43625 5.7302C3.43625 5.87692 3.38009 6.02363 3.26833 6.13538L1.95424 7.44947H7.44788L7.44788 1.95583L6.13378 3.26993C5.9097 3.49401 5.54751 3.49401 5.32343 3.26993C5.09936 3.04585 5.09936 2.68366 5.32343 2.45958L7.61579 0.16722C7.83873 -0.0562855 8.20493 -0.0545662 8.42614 0.16722Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaMoveIcon;
